export default {
    Signs: 'Signer|Signatures',
};
